import React from "react";
import { MdStarOutline } from "react-icons/md";
import Menu from "../../components/Menu";
import {
  PageContent,
  EmptyState,
  EmptyIcon,
  EmptyTitle,
  EmptyText,
} from "./styled";

export default function Favoritos() {
  return (
    <>
      <Menu title="Favoritos" />
      <PageContent>
        <EmptyState>
          <EmptyIcon>
            <MdStarOutline size={48} />
          </EmptyIcon>
          <EmptyTitle>Nenhum favorito salvo</EmptyTitle>
          <EmptyText>
            Adicione linhas e viagens aos seus favoritos para
            acess&aacute;-las rapidamente
          </EmptyText>
        </EmptyState>
      </PageContent>
    </>
  );
}
